/* eslint-disable quote-props */
export default Object.freeze({
  Baltimore: {
    'Bar Olympics': {
      title: 'Baltimore Bar Olympics - Bar Game Leagues | Volo Baltimore',
      meta: 'Compete in the ultimate Baltimore bar competition - Bar Olympics! Every week, your team will compete in a different bar game to be crowned champ.',
    },
    Basketball: {
      title: "Baltimore Men's & Coed Basketball Leagues | Volo Baltimore",
      meta: "Shoot some hoops with your friends in men's and coed basketball leagues in Baltimore. Play indoor in Mt. Washington and more.",
    },
    Bocce: {
      title: 'Bocce Leagues in Baltimore | Volo Baltimore',
      meta: 'Enjoy Baltimore Bocce in the most social leagues in the city. Play in a bocce league in Federal Hill, Canton, Hamden, Fells Point, and more!',
    },
    Bootcamp: {
      title: 'Fitness Bootcamp in Baltimore | Volo Baltimore',
      meta: 'Get fit by joining a fitness bootcamp in Baltimore. Attend with friends or meet new people. Register online today!',
    },
    Cornhole: {
      title: 'Cornhole Leagues in Baltimore | Volo Baltimore',
      meta: 'Relax in our laid back Cornhole leagues in Baltimore. Play at the most stunning waterfront locations in Federal Hill, Fells Point, and more!',
    },
    Darts: {
      title: 'Baltimore Darts Leagues in Canton | Volo Baltimore',
      meta: 'Play in one of our Darts Leagues in Baltimore located in bars in Federal Hill, Canton, Fells Point, Hamden, and more.',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in Baltimore  | Volo Baltimore',
      meta: "Execute the 5 D's of Dodgeball in Baltimore's most social Dodgeball leagues. Play  with us in Federal Hill, Canton, Mt Washington, and more.",
    },
    'Field Hockey': {
      title: 'Field Hockey Leagues in Baltimore | Volo Baltimore',
      meta: 'Play in one of the only adult field hockey leagues in Baltimore. Play on premier turf fields in Canton in our Coed field hockey leagues.',
    },
    'Flag Football': {
      title: 'Flag Football Leagues in Baltimore | Volo Baltimore',
      meta: 'Compete and have fun in our adult flag football leagues in Baltimore. Play on premier turf fields in Federal Hill and Canton.',
    },
    Kickball: {
      title: 'Adult Kickball Leagues in Baltimore | Volo Baltimore',
      meta: 'Socialize in one of the most fun Kickball leagues in Baltimore. Play on little league fields in Federal Hill, turf in Canton, or grass in Patterson Park.',
    },
    Sailing: {
      title: 'Adult Sailing Series in Baltimore | Volo Baltimore',
      meta: 'Join our Baltimore sailing series and experience the city on the water. No experience required, and you will learn a new skill along the way.',
    },
    Shuffleboard: {
      title: 'Fed Hill Shuffleboard Leagues in Baltimore | Volo Baltimore',
      meta: 'Get social in one of our Baltimore Shuffleboard Leagues. You can play at bars in Canton, Federal Hill, Hamden, Fells Point, and more.',
    },
    Skeeball: {
      title: 'Skeeball Leagues in Baltimore | Volo Baltimore',
      meta: 'Meet new people in our social skeeball leagues in Baltimore. Skeeball leagues are conveniently played at bars in Fed Hill, Canton, Hamden, and more.',
    },
    Soccer: {
      title: 'Soccer Leagues in Baltimore | Volo Baltimore',
      meta: 'Compete in top coed soccer leagues in Baltimore. Play on premier turf fields in Federal Hill, Canton, and more.',
    },
    Softball: {
      title: 'Softball Leagues in Baltimore | Volo Baltimore',
      meta: 'Play in adult softball leagues in Baltimore with your friends. Play with wood bats in Federal Hill, or metal bats in Canton or more.',
    },
    Volleyball: {
      title: 'Volleyball Leagues in Baltimore | Volo Baltimore',
      meta: 'Play beach volleyball leagues in Baltimore at the best locations. Our adult volleyball leagues are held on sand courts with food and beverage on site.',
    },
    Yoga: {
      title: 'Yoga Classes & Series in Baltimore | Volo Baltimore',
      meta: 'Join a yoga series in Baltimore. Sign up for a multi-day series or a one day yoga class with friends or solo. Sign up today!',
    },
  },
  Boston: {
    Basketball: {
      title: 'Basketball Leagues in Boston | Volo Boston',
      meta: "Play in competitive yet social men's and coed basketball leagues in Boston. Easily sign up today to play!",
    },
    Bocce: {
      title: 'Bocce Leagues in Boston | Volo Boston',
      meta: 'Play Bocce in the most social leagues in Boston. Enjoy a friendly atmosphere and meet new people in Boston. Register online.',
    },
    Cornhole: {
      title: 'Cornhole Leagues in Boston | Volo Boston',
      meta: 'Enjoy cornhole leagues in the most social leagues Boston. Play in Southie, East Boston, Somerville, and more neighborhoods around the city.',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in Boston | Volo Boston',
      meta: "Execute the 5 D's of Dodgeball in Boston's most social Dodgeball leagues. Seamlessly register online today.",
    },
    'Flag Football': {
      title: 'Flag Football Leagues in Boston | Volo Boston',
      meta: "Compete and have fun in our adult men's or coed flag football leagues in Boston. Play in Southie, East Boston, Somerville, and more neighborhoods in Boston!",
    },
    Kickball: {
      title: 'Adult Kickball Leagues in Boston | Volo Boston',
      meta: "Enjoy Boston's most social kickball leagues in the city! Play in Southie, East Boston, Somerville, and more neighborhoods around the city! Register today!",
    },
    Soccer: {
      title: 'Social Boston Soccer Leagues | Volo Boston',
      meta: "Lace up those cleats and play in competitive yet social men's or coed soccer leagues in Boston. Play in Southie, East Boston, Somerville, and more.",
    },
    Softball: {
      title: 'Social Boston Sports Softball Leagues | Volo Boston',
      meta: "Step up to the plate and play in Boston's most social men's or coed softball leagues. Play in Southie, East Boston, Somerville, and more! Register online!",
    },
    Volleyball: {
      title: 'Social Boston Sports Volleyball Leagues | Volo Boston',
      meta: 'Play in competitive yet social volleyball leagues in Boston. Join indoor, grass, or sand volleyball in Carson Beach. Leagues designed for players of all levels.',
    },
    Bowling: {
      title: 'Social Bowling Leagues in Boston | Volo Boston',
      meta: 'Play in competitive yet social bowling leagues in Boston. Join our bowling leagues in Southie. Easily register online today!',
    },
  },
  Denver: {
    Bocce: {
      title: 'Bocce Leagues in Denver | Volo Denver',
      meta: 'Play Bocce in the most social leagues in Denver. Enjoy a friendly atmosphere and meet new people in Denver.Easily register online!',
    },
    Cornhole: {
      title: 'Cornhole Leagues in Denver | Volo Denver',
      meta: 'Enjoy cornhole leagues in the most social leagues Denver. Play in Lodo, South Broadway, LoHi, and more.Sign up today!',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in Denver | Volo Denver',
      meta: "Execute the 5 D's of Dodgeball in Denver's most social, coed, Dodgeball leagues. Play with us in Lodo, RiNo, and more.",
    },
    'Flag Football': {
      title: 'Adult Flag Football Leagues in Denver | Volo Denver',
      meta: "Compete and have fun in our adult men's or coed flag football leagues in Denver. Play in Uptown, Downtown, Montbello, and more neighborhoods around the city!",
    },
    Kickball: {
      title: 'Kickball Leagues in Denver | Volo Denver',
      meta: "Enjoy Denver's most social kickball leagues in the city! Play in Lodo, Cherry Creek, Highlands and more! Relive your recess glory days and meet new people!",
    },
    Skeeball: {
      title: 'Skeeball Leagues in Denver | Volo Denver',
      meta: 'Meet new people in our social skeeball leagues in Denver. Skeeball leagues are conveniently played at bars in Lodo, South Broadway, and more.',
    },
    Soccer: {
      title: 'Coed Soccer Leagues in Denver | Volo Denver',
      meta: "Lace up those cleats and play in competitive yet social men's or coed soccer leagues in Denver. Play in Lodo, Cherry Creek, Sloan's Lake and beyond.",
    },
    Softball: {
      title: 'Adult Softball Leagues in Denver | Volo Denver',
      meta: "Step up to the plate and play in a social softball league in Denver. Join a traditional or Chicago style league in Lodo, Sloan's Lake, Barnum and more.",
    },
    Volleyball: {
      title: 'Volleyball Leagues in Denver | Volo Denver',
      meta: 'Play in competitive yet social volleyball leagues in Denver. Join indoor, grass, or beach volleyball.Leagues are social and designed for players of all levels.',
    },
    Yoga: {
      title: 'Yoga Classes in Denver | Volo Denver',
      meta: 'Get active and get social with yoga in Denver.Gather for social, fun, and healthy yoga classes. Classes are held outdoors in unique locations.',
    },
  },
  'New York Metro Area': {
    Basketball: {
      title: 'Basketball Leagues in New York City | Volo New York',
      meta: "Play with NYC Social in competitive yet social men's and coed basketball leagues in NYC. Play in Chelsea, Brooklyn, Upper East Side, and beyond.",
    },
    Bocce: {
      title: 'Bocce Leagues in New York City | Volo New York',
      meta: 'Enjoy NYC Social Bocce in the most social leagues in the city. Play in Manhattan, Brooklyn, or Queens! Easily register for a league online today!',
    },
    Bowling: {
      title: 'Bowling Leagues in New York City | Volo New York',
      meta: 'Enjoy NYC Bowling in the most social bowling league in New York City.Play with friends and meet new people! Register online today!',
    },
    Cornhole: {
      title: 'Cornhole Leagues in New York City | Volo New York',
      meta: 'Enjoy NYC Social Cornhole leagues in the most social leagues in the city. Play in Manhattan, Brooklyn, or Queens! Sign up today!',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in New York City | Volo New York',
      meta: "Execute the 5 D's of Dodgeball in NYC Social, NYC's most social, coed, Dodgeball leagues. Play with us in Murray Hill, LES, Williamsburg, and more.",
    },
    'Flag Football': {
      title: 'Flag Football Leagues in New York City | Volo New York',
      meta: "Compete and have fun with NYC Social in our adult men's or coed flag football leagues in NYC. Play in Chelsea, Lower East Side, Williamsburg and more.",
    },
    'Flip Cup': {
      title: 'Flip Cup Leagues in New York City | Volo New York',
      meta: "Just want to be social ? Join NYC Social's most social flip cup league and meet new people! Prepare for a premiere fun experience!",
    },
    Kickball: {
      title: 'Kickball Leagues in New York City | Volo New York',
      meta: "Enjoy NYC's most social kickball leagues in the city! Play in Chelsea, Murray Hill, Williamsburg, and more! Join NYC Social Kickball and meet new people.",
    },
    Skeeball: {
      title: 'Skeeball Leagues in New York City | Volo New York',
      meta: 'Meet new people in our social skeeball leagues in New York City. Leagues are played at bars in Murray Hill, Union Square, Lower East Side, and more.',
    },
    Soccer: {
      title: 'Soccer Leagues in New York City | Volo New York',
      meta: 'Play with NYC Social and compete in our competitive yet social coed soccer leagues in NYC. Play in Chelsea, Lower East Side, Brooklyn, and more.',
    },
    Softball: {
      title: 'Softball Leagues in New York City | Volo New York',
      meta: 'Step up to the plate with Volo New York and play in social softball leagues. Join a wood bat or metal bat league in Williamsburg, Murray Hill, and more.',
    },
  },
  'San Francisco': {
    Kickball: {
      title: 'Volo San Francisco Kickball Leagues | Volo San Francisco',
      meta: 'Socialize in the most fun Kickball leagues in San Francisco. Join Volo San Francisco Kickball and meet new people. Sign up now!',
    },
    Soccer: {
      title: 'Soccer Leagues in San Francisco | Volo San Francisco',
      meta: 'Play with Volo San Francisco and compete in our competitive yet social coed soccer leagues in SF. Register today!',
    },
    Sailing: {
      title: 'Sailing series in San Francisco | Volo San Francisco',
      meta: 'Join our sailing series in San Francisco and experience the city on the water. No experience required. Register online today!',
    },
    Basketball: {
      title: 'Adult Basketball Leagues in San Francisco | Volo SF',
      meta: 'Shoot some hoops with your friends in adult basketball leagues in San Francisco. Join Volo San Francisco Basketball to meet new people!',
    },
    Bocce: {
      title: 'Bocce Leagues in San Francisco | Volo San Francisco',
      meta: 'Play in adult social sports leagues in San Francisco, CA. Kickball, Bocce, Skeeball, Soccer, Volleyball and more. Sign up today!',
    },
    Bootcamp: {
      title: 'Fitness Bootcamp classes in San Francisco | Volo SF',
      meta: 'Get fit by participating in a fitness bootcamp classes in San Francisco. Join with friends or meet new people. Register online today!',
    },
    Yoga: {
      title: 'Yoga Leagues in San Francisco | Volo San Francisco',
      meta: 'Get active and social by joining a yoga league in San Francisco. Gather for a social, fun, and healthy yoga class. Sign up today!',
    },
    Cornhole: {
      title: 'Cornhole Leagues in San Francisco | Volo San Francisco',
      meta: 'Relax in our laid back Cornhole leagues with your friends in the most social leagues San Francisco. Sign up now to join the fun!',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in San Francisco | Volo San Francisco',
      meta: "Execute the 5 D's of Dodgeball in our dodgeball leagues in San Francisco. Play alone or with friends. Easily register online today!",
    },
    'Flag Football': {
      title: 'Flag Football Leagues in San Francisco | Volo SF',
      meta: "Compete and have fun in our adult men's or coed flag football leagues in San Francisco. Join as a free agent or with friends. Register today!",
    },
    Softball: {
      title: 'Softball Leagues in San Francisco | Volo San Francisco',
      meta: 'Step up to the plate and play in a social softball league in San Francisco. Join a traditional or Chicago style league. Easily sign up today!',
    },
    Volleyball: {
      title: 'Beach Volleyball leagues in San Francisco | Volo SF',
      meta: 'Join our competitive yet social beach volleyball leagues in San Francisco. Play with your friends and meet new people. Sign up now!',
    },
  },
  Seattle: {
    Bocce: {
      title: 'Bocce Leagues in Seattle | Volo Seattle',
      meta: 'Join the top, social, Seattle bocce leagues. Compete and make new friends playing bocce. Sign up for a league today!',
    },
    Kickball: {
      title: 'Kickball Leagues in Seattle | Volo Seattle',
      meta: 'Socialize in the most fun Kickball leagues in Seattle. Join Volo Seattle Kickball and meet new friends. Sign up now!',
    },
    Skeeball: {
      title: 'Skeeball Leagues in Seattle | Volo Seattle',
      meta: 'Meet new people in our social skeeball leagues in Seattle. Prepare for a premiere, fun, experience! Seamlessly register online.',
    },
  },
  'Washington DC': {
    'Field Hockey': {
      title: 'Field Hockey Leagues in Washington DC | Volo DC',
      meta: 'Play in one of the only adult coed field hockey leagues in DC. Play on premier turf fields. Get active and get social with Volo.',
    },
    Skeeball: {
      title: 'Skeeball Leagues in Washington DC | Volo DC',
      meta: 'Meet new people in our social skeeball leagues in DC. Sign up for match play or traditional skeeball. Get active and get social with Volo.',
    },
    Basketball: {
      title: 'Adult Basketball Leagues in Washington DC | Volo DC',
      meta: 'Play in one of the only adult coed field hockey leagues in DC. Play on premier turf fields. Easy online registration!',
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in Washington DC | Volo DC',
      meta: "Execute the 5 D's of Dodgeball in DC's most social Dodgeball leagues. Get active and get social with Volo.",
    },
    Softball: {
      title: 'Softball Leagues in Washington DC | Volo DC',
      meta: "Step up to the plate and play in DC's most social softball league. Join a wood bat or metal bat league. Sign up today!",
    },
    'Flag Football': {
      title: 'Flag Football Leagues in Washington DC | Volo DC',
      meta: "Compete and have fun in our adult men's or coed flag football leagues in DC. Get active and get social with Volo!",
    },
    Kickball: {
      title: 'Kickball Leagues in Washington DC | Volo DC',
      meta: "Enjoy DC's most social kickball leagues! Play traditional kickball on the National Mall or Cup In Hand at Buzzard Point. Register today!",
    },
    Volleyball: {
      title: 'Volleyball Leagues in Washington DC | Volo DC',
      meta: 'Play in competitive yet social volleyball leagues in DC. Join indoor, grass or beach volleyball. Get active and get social with Volo.',
    },
    Bocce: {
      title: 'Bocce Leagues in Washington DC | Volo DC',
      meta: 'Enjoy DC Bocce in the most social leagues in the city. Meet new people and have fun with Volo! Register online today!',
    },
    Bowling: {
      title: 'Bowling Leagues in Washington DC | Volo DC',
      meta: 'Enjoy DC Bowling in the most social league in the city. Meet new people and have fun with Volo! Easily register online!',
    },
    Cornhole: {
      title: 'Cornhole Leagues in Washington DC | Volo DC',
      meta: 'Enjoy DC Cornhole leagues in the most social leagues in the city. Meet new people and have fun with Volo!',
    },
  },
  'San Diego': {
    Basketball: {
      title: 'Adult Basketball Leagues in San Diego | Volo San Diego',
      meta: "Play in competitive yet social men's and coed basketball leagues in San Diego. Our basketball games are fast paced. Sign up now!",
    },
    Dodgeball: {
      title: 'Dodgeball Leagues in San Diego | Volo San Diego',
      meta: 'Join fun and competitive dodgeball leagues in San Diego. Socialize and get a great workout by playing Volo dodgeball. Sign up today!',
    },
    'Flag Football': {
      title: 'Adult Flag Football Leagues in San Diego | Volo San Diego',
      meta: 'Compete and have fun in our adult flag football leagues in San Diego. Play with friends in Linda Vista, Clairemont, Pacific Beach and more!',
    },
    Golf: {
      title: 'Social Golf Leagues in San Diego | Volo San Diego',
      meta: 'Join a social golf league in San Diego to meet new people and compete with other golf lovers. Enjoy our golf leagues in Pacific Beach. Sign up online!',
    },
    Kickball: {
      title: 'Adult Kickball Leagues in San Diego | Volo San Diego',
      meta: 'Socialize by joining an adult kickball league in San Diego. Play in areas such as Pacific Beach, Ocean Beach, Carmel Valley and more! Sign up now!',
    },
    Soccer: {
      title: 'Soccer Leagues in San Diego | Volo San Diego',
      meta: "Lace up those cleats and play in competitive yet social men's or coed soccer leagues in San Diego. Play on both line turf and grass fields. Register today!",
    },
    Softball: {
      title: 'Adult Softball Leagues in San Diego | Volo San Diego',
      meta: 'Step up to the plate and join an adult softball league in San Diego. Compete and meet new friends in our social leagues. Register today!',
    },
    Tennis: {
      title: 'Social Tennis Leagues in San Diego | Volo San Diego',
      meta: 'Play in social tennis leagues in San Diego. We offer a variety of adult tennis leagues for all experience levels. Easily register online.',
    },
    Volleyball: {
      title: 'Volleyball Leagues in San Diego | Volo San Diego',
      meta: 'Join our competitive yet social beach volleyball leagues in San Diego. Play with your friends or meet new people. Sign up today!',
    },
    Hiking: {
      title: 'Guided Hiking Club and Programs in San Diego | Volo San Diego',
      meta: 'Socialize and enjoy the scenery by joining a guided hike in San Diego. Seamlessly register online today!',
    },
  },
});
